import i18n from '../../i18n';
import OrganizationRole from '../../models/enums/organization-roles';
import ValidationResult from '@common/interfaces/api/validation-result';

export const validateOrganizationName = (
  name: string,
  role: OrganizationRole,
): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-organization-name-' + role),
  };
};

export const validateOrganizationPhoneNumber = (number: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-organization-phone-number'),
  };
};

export const validateOrganizationAddress = (address: string): ValidationResult => {
  return {
    isValid: true,
    error: null,
  };
};

export const validateOrganizationCity = (city: string): ValidationResult => {
  return {
    isValid: true,
    error: null,
  };
};

export const validateOrganizationZipCode = (code: string): ValidationResult => {
  return {
    isValid: true,
    error: null,
  };
};

export const validateOrganizationSupportPhoneNumber = (phoneNumber: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-organization-support-phone-number'),
  };
};

export const validateSupportEmail = (email: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-organization-support-email'),
  };
};

export const validateOrganizationUserLimit = (limit: number): ValidationResult => {
  return {
    isValid: true,
    error: null,
  };
};

export const validateOrganizationLocationLimit = (limit: number): ValidationResult => {
  return {
    isValid: true,
    error: null,
  };
};
